/* eslint-disable max-len */

export const en = {
  translation: {
    common: {
      aquarius: 'aquarius',
      aries: 'aries',
      cancer: 'cancer',
      capricorn: 'capricorn',
      gemini: 'gemini',
      leo: 'leo',
      libra: 'libra',
      pisces: 'pisces',
      sagittarius: 'sagittarius',
      scorpio: 'scorpio',
      taurus: 'taurus',
      virgo: 'virgo',
      male: 'males',
      female: 'females',
      man: 'man',
      woman: 'woman',
      plural: {
        aquarius: 'aquarians',
        aries: 'aries',
        cancer: 'cancers',
        capricorn: 'capricorns',
        gemini: 'geminis',
        leo: 'leos',
        libra: 'libras',
        pisces: 'pisces',
        sagittarius: 'sagittarians',
        scorpio: 'scorpios',
        taurus: 'tauruses',
        virgo: 'virgos',
        man: 'men',
        woman: 'women',
      },
    },
    'app-subscription-4-7d-trial-per-day': {
      unlimitedReadings: {
        disclaimer:
          "Please note: In addition to your subscription, your account will incur recurring charges of {{price}} per month for the selected add-ons when you choose the 'Add unlimited readings' option. Items on this page are {{period}} subscriptions. Unless you cancel it in your profile before the end of the then-current period, you agree that the subscription will renew automatically at the end of each period. If you need help with how to cancel, visit our ",
      },
      trialPaymentWithDiscount: {
        offer: 'SECRET discount <bold>65% off</bold> applied',
        title: 'You get a secret discount!',
        pay: 'Start your 7-day trial',
        subtitle: 'No pressure. Cancel anytime.',
        specialCode: 'Secret discount applied!',
        price: 'Your cost per 2 weeks after trial:',
        priceExperiment: 'Your cost per 1 month after trial:',
        saveMoney: 'You save {{savedMoney}} every period',
        saveMoneyExperiment: 'You save {{savedMoney}}',
        total: 'Total today:',
        description: `By continuing you agree that if you don't cancel prior to the end of the 7-days trial, you will automatically be charged {{discountPrice}} for the introductory period of 2 weeks thereafter the standard rate of {{fullPrice}} every 2 weeks until you cancel in settings. Learn more about cancellation and refund policy in `,
        descriptionExperiment: `By continuing you agree that if you don't cancel prior to the end of the 7-days trial, you will automatically be charged {{discountPrice}} for the introductory period of 30 days thereafter the standard rate of {{fullPrice}} every 30 days until you cancel in settings. Learn more about cancellation and refund policy in `,
        terms: 'Subscription terms',
      },
      salesScreen: {
        fixedHeader: {
          title: `Discount expires in`,
          minutes: 'min',
          seconds: 'sec',
          button: 'get my reading',
        },
        charge: {
          trial:
            'You will be charge only <bold>{{trialPrice}} for your 7-day trial.</bold><br/>' +
            'We’ll <bold>email you a reminder</bold> before your trial period ends. ' +
            '<bold>Cancel anytime.</bold>',
          europeanTrial:
            'You will be charged only <bold>{{europeanTrialPrice}}</bold> ' +
            'for your 7-day trial.<br/> We’ll <bold>email you a reminder</bold> ' +
            'before your trial period ends. <bold>Cancel anytime.</bold>',
          trialUSStart: 'You are enrolling in a 2-week subscription to ',
          trialUSEnd:
            " service. By continuing you agree that if you don't" +
            ' cancel prior to the end of the 7-day trial for the {{trialPrice}} you will automatically be charged' +
            ' {{fullPrice}} every 2 weeks until you cancel in settings.' +
            ' Learn more about cancellation and refund policy in',
          trialUS:
            "You are enrolling in monthly subscription to NEBULA service. By continuing you agree that if you don't" +
            ' cancel prior to the end of the 7-day trial for the {{trialPrice}} you will automatically be charged' +
            ' {{fullPrice}} every 30 days until you cancel in settings. The charge will appear on your bill as' +
            ' {{domainUrl}}. Learn more about cancellation and refund policy in ',
        },
        description: {
          text:
            'You are enrolling in 2 weeks subscription to NEBULA service. ' +
            "By continuing you agree that if you don't cancel prior to the end of the 7-day trial " +
            'for the <bold>{{trialPrice}}</bold> ' +
            'you will automatically be charged <bold>{{plan}} ' +
            'every 2 weeks </bold> until you cancel in settings. The charge will appear on your bill as {{domainUrl}}. Learn more about ' +
            'cancellation and refund policy in ',
          textEU:
            'You are enrolling in 2 weeks subscription to NEBULA service. ' +
            "By continuing you agree that if you don't cancel prior to the end of the 7-days trial " +
            'for the <bold>{{europeanTrialPrice}}</bold>, you will ' +
            'automatically be charged {{europeanTrialPrice}}  ' +
            'thereafter the standard rate of <bold>{{plan}} every 2 weeks</bold> until ' +
            'you cancel in settings. The charge will appear on your bill as {{domainUrl}}. Learn more about cancellation and refund policy in ',
          terms: 'Subscription policy',
          termsEU: 'Subscription terms',
          termsExperiment: 'Subscription terms',
        },
        trialChoiceDescription: {
          header:
            "We've helped millions of people to have happier lives and better relationships, and " +
            'we want to help you, too.',
          money:
            'Money shouldn’t stand in the way of finding astrology guidance that finally works. So, please choose an amount that you think is reasonable to try us out for one week.',
          paymentDescription:
            'It costs us  {{priceForUs}} to offer a 7-day trial, but please choose the amount ' +
            'you are comfortable with.',
        },
      },
      payment: {
        title: 'Choose payment method',
        divider: 'or',
        chargeDisclaimer: 'You will be charged only',
        form: {
          default: {
            submitButtonText: 'Start',
            charged: 'You will be charged only {{price}}{{currencySymbol}} for your 7-day trial.',
            chargedExperiment:
              'You will be charged only {{price}}{{currencySymbol}} for your 3-day trial.',
          },
          resign: {
            submitButtonText: 'Buy',
          },
        },
        charge: {
          trialWithoutPrice:
            'We’ll <bold>email you a reminder</bold> before your trial period ends. ' +
            '<bold>Cancel anytime.</bold>',
          trial:
            'You will be charged only <bold>{{price}} for your {{trialPeriod}} trial.</bold><br/>' +
            'We’ll <bold>email you a reminder</bold> before your trial period ends. Cancel anytime.',
          trialUS:
            'You will only be charged the <bold>{{price}} for your 7-day trial period.</bold> ' +
            'We <bold>will send you an email reminder</bold> before the end of your trial period.  ' +
            'You can cancel at any time. The charge will appear on your invoice as {{domainUrl}}.',
          full: 'You will be charged only <bold>{{price}} for your {{trialPeriod}} trial.</bold>',
          email:
            'We’ll <bold>email you a reminder</bold> before your trial period ends. ' +
            '<bold>Cancel anytime.</bold>',
        },
        pay: {
          trial: 'Your <bold>{{trialPeriod}} trial</bold>',
          price: 'Only',
          tax: 'Value added tax',
          total: 'Total',
        },
        resources: 'Guaranteed security payments',
      },
      upsells: {
        header: {
          step1: 'Buy reading',
          step2: 'Consultations',
          step3: 'Access product',
          banner: {
            title: 'Thank you!',
            text: 'Your order was successful!',
          },
          title: 'Choose your sign-up offer',
          subtitle: 'Available only now',
        },
        headerNew: {
          addReport: 'Add Report',
          unlimitedReadings: 'Unlimited Readings',
          addConsultation: 'Add Consultation',
          accessProduct: 'Access Product',
        },
        footer: {
          description:
            '*You will be charged for the add-on services or offers selected at the time of their preparation and delivery to your email.<br/>' +
            'This is a non-recurring payment.',
        },
        button: 'Get my copy',
        link: 'Skip this offer and proceed further',
      },
      trialCredits: {
        header: {
          step1: 'Buy reading',
          step2: 'Consultations',
          step3: 'Access product',
          title: 'More for you',
          subtitle: 'Exclusive offer recommended for you to achieve your goals faster',
        },
        payment: {
          title: 'Your unique individual consultation',
          consultation:
            '<highlight>30-minute private </highlight><br />' +
            '<highlight>consultation with an expert</highlight>',
          description:
            'You can ask for prediction of the future, live compatibility analysis; love compatibility etc',
          offerPrice: 'One time price offer:',
          originalPrice: {
            price: 'Original price:',
            discount: 'Save',
          },
        },
        footer: {
          description:
            '*You will be charged for the add-on services or offers selected at the time of their preparation and delivery to your email.' +
            '<br /> This is a non-recurring payment.',
        },
        button: 'Get my consultation',
        link: 'Skip this offer and proceed further',
      },
    },
    'natal-chart': {
      progressBar: 'Take control of your life',
      billingScreen: {
        description:
          'By continuing you agree that you will automatically be charged {{price}} every month until you cancel in settings. Learn more about cancellation and refund policy in ',
        trialDescription:
          "You are enrolling in <bold>7-day subscription</bold> to NEBULA service. By continuing you agree that if you don't cancel prior to the end of the <bold>7-days trial for {{trialPrice}}</bold>, you will automatically be charged {{price}} every month until you cancel in settings. Learn more about cancellation and refund policy in ",
        terms: 'Subscription terms.',
      },
    },
    agreement: {
      text: 'By selecting option above you agree to',
      policy: 'the Privacy policy',
      separator: 'and',
      terms: 'Terms of use.',
      textEnd: '',
    },
    emailAgreement: {
      text: 'By continuing, I agree to',
      policy: "Nebula's Privacy policy",
      separator: 'and',
      terms: 'Terms of Use.',
      textEnd: '',
    },
    paymentFailed: {
      title: 'Payment failed',
      text: 'Your transaction has failed due to some technical error. Please, try again.',
      button: 'Try again',
    },
  },
};
